import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_ERROR, AUTH_CHECK, AUTH_GET_PERMISSIONS } from 'react-admin';
import configuration from './config.js';

export default (type, params) => {
    if (type === AUTH_LOGIN) {
        const { username, password } = params;
        const request = new Request(configuration.api + '/auth/login', {
            method: 'POST',
            body: JSON.stringify({
                                    'email' :  username , 
                                    'password' : password,
                                    'remember_me' : true
                                }),
            headers: new Headers({ 'Content-Type': 'application/json',
                                    'X-Requested-With' : 'XMLHttpRequest' ,
                                    'Access-Control-Allow-Origin': '*'  }),
        })

        console.log(request);

        return fetch(request)
            .then(response => {
                if (response.status < 200 || response.status >= 300) {
                    throw new Error(response.statusText);
                }
                return response.json();
            })
            .then(({ access_token , user}) => {
                localStorage.setItem('token', access_token);
                localStorage.setItem("user", JSON.stringify(user));
                localStorage.setItem("username",  user.name );
                localStorage.removeItem('dbloades');
            });
    }
    if (type === AUTH_LOGOUT) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('username');
        return Promise.resolve();
    }
    if (type === AUTH_ERROR) {
        const status  = params.status;
        if (status === 401 || status === 403) {
            localStorage.removeItem('token');
            return Promise.reject();
        }
        return Promise.resolve();
    }
    if (type === AUTH_CHECK) {
        return localStorage.getItem('token') ? Promise.resolve() : Promise.reject();
    }
    if (type === AUTH_GET_PERMISSIONS) {
        const role = JSON.parse(localStorage.getItem("user")).type;
        return role ? Promise.resolve(role) : Promise.reject();
    }
    return Promise.reject('Unknown method');
}
